<style scoped lang="scss">
    .status {
        background: #E6F1FC;
        height: 40px;
    }
</style>
<template>
    <div class="container bg_fff">
        <breadcrumb :pages="pages"></breadcrumb>
        <el-tabs v-model="activeName" type="card" class="mt15">
            <el-tab-pane label="基本资料" name="first">
                <div class="pl15 pr15 pb15">
                    <diagnose-base-form></diagnose-base-form>
                    <diagnose-diagnose-form></diagnose-diagnose-form>
                    <diagnose-consultation-form></diagnose-consultation-form>
                    <div class="flex jcc">
                        <el-button type="danger" size="mini">拒绝</el-button>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="远程B超" name="second" class="pl15 pb15">远程B超</el-tab-pane>
            <el-tab-pane label="报告书写" name="third" class="pl15 pb15">书写报告</el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>

  import Breadcrumb from "../../components/common/Breadcrumb";
  import {diagnoseMixin} from "../../lib/mixins/diagnose";
  import DiagnoseBaseForm from "../../components/dignose/base-form";
  import DiagnoseDiagnoseForm from "../../components/dignose/diagnose-form";
  import DiagnoseConsultationForm from "../../components/dignose/consultation-form";

  export default {
    name: "DiagnoseApply",
    data() {
      return {
        activeName: 'first',
        form: {
          status: '1'
        }
      }
    },
    computed: {},
    components: {DiagnoseConsultationForm, DiagnoseDiagnoseForm, DiagnoseBaseForm, Breadcrumb},
    mixins: [diagnoseMixin],
    created() {

    },
    methods: {}
  }
</script>
